import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {api} from "../../../maps/data";
import useZibi from "../../../zibi/UseZibi";
import Paper from "@mui/material/Paper";
import {
    DataTableInfoData, ImagePreviewInfoData, InvAlertBox, LoaderStyled
} from "./invCommonStyles";
import {CircularProgress} from "@mui/material";
import ALERT_MAP from "../../../maps/alertMap";

const WrapperStyled = styled.div`
    display: grid;
    grid-gap: 15px;
    width: 900px;
`;

const InvAlertInfoData = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 25px;
`;

const LowInventory = ({getProducts, eventId}) => {
    const selectedDivRef = useRef(null);
    const [dashboardData, s_dashboardData] = useState([]);
    const [placements, s_placements] = useState({});
    const [updater, s_updater] = useState(0);

    const [productsById] = useZibi('productsById');

    useEffect(() => {
        if (eventId && selectedDivRef.current) {
            selectedDivRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }, [eventId, selectedDivRef?.current]);

    useEffect(() => {
        setTimeout(() => {
            s_updater(updater + 1);
        }, 700);
    }, []);

    const getPlacements = async (ids) => {
        api({
            type: "getPlacements",
            data: {
                productIds: ids
            }
        }).then(data => {
            const temp = {};
            data.forEach(dd => {
                if (!temp[dd.sensorId]) {
                    temp[dd.sensorId] = [];
                }
                temp[dd.sensorId].push(dd);
            });
            s_placements(temp);
        }).catch(e => {
            console.error(e);
        });
    };

    const getDashboardData = async () => {
        api({
            type: "getAlertsByParams", data: {
                statuses: [ALERT_MAP.statuses.ACTIVE],
                eventTypes: [ALERT_MAP.eventMainTypes.SHELF_BOUNCER],
                eventEntitys: [ALERT_MAP.eventEntitys.ALERT],
                eventSubTypes: [ALERT_MAP.eventTypesList.LOW_INVENTORY],
                limit: 40
            }
        }).then(data => {
            s_dashboardData(data);
            const productIds = new Set();
            data.forEach((item) => {
                productIds.add(item.data.productId);
            });
            getProducts(Array.from(productIds));
            getPlacements(Array.from(productIds));
        }).catch(e => {
            console.error(e);
        });
    };

    useEffect(() => {
        getDashboardData();
    }, []);

    return (<WrapperStyled>
        <h2>Low Inventory</h2>
        {dashboardData.map((item) => {
            const product = productsById[item.data.productId];
            const placementsCount = placements?.[item?.data?.sensorId]?.length || 0;

            const isLoading = !!!product;

            const selectedEvent = eventId === item._id;

            let productInfoMap = [];
            const storageInfoMap = [
                {
                    label: "Storage", value: `${item.data?.quantity} / ${item.data?.totalQuantity}`,
                }, {
                    label: "On Shelves", value: placementsCount,
                }
            ];
            if (product) {
                productInfoMap = [
                    {
                        label: "Name", value: product.name,
                    }, {
                        label: "Category", value: product.category,
                    }, {
                        label: "Barcode", value: product.barcode,
                    }
                ];
            }

            return (<Paper elevation={1} key={item._id}>
                {isLoading && (
                    <LoaderStyled>
                        <CircularProgress/>
                    </LoaderStyled>
                )}

                {!isLoading && (
                    <InvAlertBox
                        className={selectedEvent ? "selected" : ""}
                        ref={selectedEvent ? selectedDivRef : null}
                    >
                        <InvAlertInfoData>
                            <ImagePreviewInfoData>
                                <img style={{maxWidth: 300, maxHeight: 200}} src={product.imageUrl} alt=""/>
                            </ImagePreviewInfoData>
                            <DataTableInfoData>
                                {productInfoMap.map((item) => {
                                    return (
                                        <div key={item.label}>
                                            <span className="label">
                                                {item.label}
                                            </span>
                                            <span className="value">
                                                {item.value}
                                            </span>
                                        </div>
                                    );
                                })}
                            </DataTableInfoData>
                            <DataTableInfoData>
                                {storageInfoMap.map((item) => {
                                    return (
                                        <div key={item.label}>
                                            <span className="label">
                                                {item.label}
                                            </span>
                                            <span className="value">
                                                {item.value}
                                            </span>
                                        </div>
                                    );
                                })}
                            </DataTableInfoData>
                        </InvAlertInfoData>
                    </InvAlertBox>
                )}
            </Paper>);
        })}
    </WrapperStyled>);
};

export default LowInventory;